import { useRecordContext } from "ra-core";
import { Mail } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import type { Contact } from "../types";
import { ContactMarketingConsent } from "./ContactMarketingConsent";

/**
 * The email address this contact asked their HD poster sent to (latest), with
 * the total posters emailed and the address's marketing consent. Projected
 * onto the contact by the dashboard-indexer from `poster.hd_email.sent`;
 * renders nothing until the contact has used the poster "HD by email" button.
 */
export const ContactPosterEmailInfo = () => {
  const record = useRecordContext<Contact>();
  const email =
    typeof record?.poster_email === "string" ? record.poster_email : "";
  if (!email) return null;
  const sentCount = Number(record?.poster_emails_sent_count ?? 0);
  const updatedAt =
    typeof record?.poster_email_updated_at === "string"
      ? record.poster_email_updated_at
      : "";

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <Mail className="size-3 text-muted-foreground" />
        <a
          href={`mailto:${email}`}
          className="underline-offset-2 hover:underline"
        >
          {email}
        </a>
      </div>
      <div className="flex items-center gap-2">
        <Badge variant="secondary">
          {sentCount || 1} poster{sentCount === 1 ? "" : "s"} emailed
        </Badge>
        {updatedAt ? (
          <span className="text-xs text-muted-foreground">
            last {new Date(updatedAt).toLocaleString()}
          </span>
        ) : null}
      </div>
      <ContactMarketingConsent email={email} />
    </div>
  );
};
